function initAudioPlayers() {
  document.querySelectorAll('.bk-media-audio-player:not([data-initialized])').forEach(function(player) {
    var audio = player.querySelector('.bk-media-audio-player__audio');
    var playBtn = player.querySelector('.bk-media-audio-player__play-btn');
    var playIcon = player.querySelector('.bk-media-audio-player__play-icon');
    var pauseIcon = player.querySelector('.bk-media-audio-player__pause-icon');
    var waveform = player.querySelector('.bk-media-audio-player__waveform');
    var bars = player.querySelectorAll('.bk-media-audio-player__waveform-bar');
    var durationEl = player.querySelector('.bk-media-audio-player__duration');
    if (!audio || !playBtn || !waveform) return;
    if (!audio.querySelector('source')) return;
    player.setAttribute('data-initialized', 'true');
    audio.load();

    function formatTime(seconds) {
      if (!isFinite(seconds) || isNaN(seconds)) return '0:00';
      var m = Math.floor(seconds / 60);
      var s = Math.floor(seconds % 60);
      return m + ':' + (s < 10 ? '0' : '') + s;
    }

    function updateDurationDisplay() {
      if (durationEl && audio.duration && isFinite(audio.duration)) {
        durationEl.textContent = formatTime(audio.duration);
      }
    }

    function stopAllOtherPlayers() {
      document.querySelectorAll('.bk-media-audio-player__audio').forEach(function(other) {
        if (other !== audio) {
          other.pause();
          var otherPlayer = other.closest('.bk-media-audio-player');
          if (otherPlayer) {
            var op = otherPlayer.querySelector('.bk-media-audio-player__play-icon');
            var oq = otherPlayer.querySelector('.bk-media-audio-player__pause-icon');
            if (op) op.style.display = '';
            if (oq) oq.style.display = 'none';
          }
        }
      });
    }

    function updateProgress() {
      if (!audio.duration || !isFinite(audio.duration)) return;
      var progress = (audio.currentTime / audio.duration) * 100;
      var waveformRect = waveform.getBoundingClientRect();
      var firstBar = bars[0];
      var barWithGap = 4;
      if (firstBar) {
        var barRect = firstBar.getBoundingClientRect();
        var gap = parseFloat(getComputedStyle(firstBar.parentElement).gap) || 2;
        barWithGap = barRect.width + gap;
      }
      var visibleCount = Math.max(1, Math.min(bars.length, Math.floor(waveformRect.width / barWithGap)));
      var playedBarsCount = (progress / 100) * visibleCount;
      var fullBars = Math.floor(playedBarsCount);
      var partialBarIndex = fullBars;
      var partialFill = playedBarsCount - fullBars;
      bars.forEach(function(bar, i) {
        bar.classList.remove('played', 'is-partially-active');
        if (i < fullBars) {
          bar.classList.add('played');
        } else if (i === partialBarIndex && partialFill > 0) {
          bar.classList.add('played', 'is-partially-active');
          bar.style.opacity = 0.3 + (0.7 * partialFill);
        } else {
          bar.style.opacity = '';
        }
      });
    }

    playBtn.addEventListener('click', function() {
      if (audio.paused) {
        stopAllOtherPlayers();
        audio.play().catch(function() {});
        setTimeout(updateDurationDisplay, 100);
        if (playIcon) playIcon.style.display = 'none';
        if (pauseIcon) pauseIcon.style.display = '';
      } else {
        audio.pause();
        if (playIcon) playIcon.style.display = '';
        if (pauseIcon) pauseIcon.style.display = 'none';
      }
    });

    playBtn.addEventListener('mouseenter', function() {
      audio.preload = 'auto';
    });

    audio.addEventListener('loadedmetadata', updateDurationDisplay);
    audio.addEventListener('durationchange', updateDurationDisplay);
    audio.addEventListener('canplay', updateDurationDisplay);
    audio.addEventListener('timeupdate', updateProgress);
    audio.addEventListener('ended', function() {
      if (playIcon) playIcon.style.display = '';
      if (pauseIcon) pauseIcon.style.display = 'none';
      bars.forEach(function(bar) {
        bar.classList.remove('played', 'is-partially-active');
        bar.style.opacity = '';
      });
    });

    waveform.addEventListener('click', function(e) {
      var rect = waveform.getBoundingClientRect();
      var clickPercentage = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      audio.currentTime = clickPercentage * audio.duration;
    });
  });
}

function initProductDescriptionReadMore() {
  document.querySelectorAll('[data-product-description-toggle]').forEach(function(btn) {
    if (btn.dataset.initialized) return;
    btn.dataset.initialized = 'true';
    var toggleId = btn.dataset.productDescriptionToggle;
    var content = document.getElementById('product-description-content-' + toggleId);
    if (!content) return;
    var expandSpan = btn.querySelector('.product-info__description-expand');
    var collapseSpan = btn.querySelector('.product-info__description-collapse');
    btn.addEventListener('click', function() {
      var isCollapsed = content.classList.contains('is-collapsed');
      if (isCollapsed) {
        content.classList.remove('is-collapsed');
        btn.setAttribute('aria-expanded', 'true');
        if (expandSpan) expandSpan.hidden = true;
        if (collapseSpan) collapseSpan.hidden = false;
      } else {
        content.classList.add('is-collapsed');
        btn.setAttribute('aria-expanded', 'false');
        if (expandSpan) expandSpan.hidden = false;
        if (collapseSpan) collapseSpan.hidden = true;
      }
    });
  });
}

function initBreadcrumbCollapse() {
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  if (window._breadcrumbCollapseInitialized) return;
  window._breadcrumbCollapseInitialized = true;
  var lastScrollTop = window.scrollY || 0;
  var ticking = false;
  var scrollThreshold = 50;
  function updateBreadcrumbs() {
    var header = document.querySelector('store-header.header[sticky]');
    var breadcrumbs = document.querySelector('.header__breadcrumbs');
    if (!header || !breadcrumbs) return;
    var scrollTop = window.scrollY || 0;
    var isScrollingDown = scrollTop > lastScrollTop;
    var pastThreshold = scrollTop > scrollThreshold;
    if (pastThreshold && isScrollingDown) {
      breadcrumbs.classList.add('is-collapsed');
    } else if (!isScrollingDown || scrollTop <= scrollThreshold) {
      breadcrumbs.classList.remove('is-collapsed');
    }
    lastScrollTop = scrollTop;
    ticking = false;
  }
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateBreadcrumbs);
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  updateBreadcrumbs();
}

function initBkMedia() {
  initProductDescriptionReadMore();
  initAudioPlayers();
  initBundleBlocks();
  initBreadcrumbCollapse();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBkMedia);
} else {
  initBkMedia();
}
document.addEventListener('shopify:section:load', function() {
  document.querySelectorAll('.bk-media-audio-player').forEach(function(p) {
    p.removeAttribute('data-initialized');
  });
  initBkMedia();
  setTimeout(initBundleBlocks, 100);
});
document.addEventListener('product:rerender', function() {
  document.querySelectorAll('.bk-media-audio-player').forEach(function(p) {
    p.removeAttribute('data-initialized');
  });
  setTimeout(initBkMedia, 100);
  setTimeout(initBundleBlocks, 250);
});

function initBundleBlocks() {
  document.querySelectorAll('[data-bundle-add]').forEach(function(btn) {
    var bundle = btn.closest('[id^="bundle-"]');
    if (!bundle || bundle.getAttribute('data-bundle-initialized')) return;
    initBundleBlock(bundle);
  });
}

function initBundleBlock(bundle) {
  var variantDataScript = (bundle.parentElement && bundle.parentElement.querySelector('[data-bundle-variants]')) || (bundle.closest('.shopify-section') && bundle.closest('.shopify-section').querySelector('[data-bundle-variants]'));
  var variantData = {};
  if (variantDataScript) {
    try {
      variantData = JSON.parse(variantDataScript.textContent);
    } catch (e) {
      console.error('Bundle: Failed to parse variant data', e);
      return;
    }
  }
  bundle.setAttribute('data-bundle-initialized', 'true');

  function findVariant(blockId, selectedOptions) {
    var blockData = variantData[blockId];
    if (!blockData) return null;
    if (blockData.hasOnlyDefaultVariant) return blockData.variants[0] || null;
    var firstVariant = blockData.variants[0];
    if (!firstVariant) return null;
    var requiredOptions = [];
    if (firstVariant.option1 != null) requiredOptions.push('option1');
    if (firstVariant.option2 != null) requiredOptions.push('option2');
    if (firstVariant.option3 != null) requiredOptions.push('option3');
    for (var r = 0; r < requiredOptions.length; r++) {
      var key = requiredOptions[r];
      if (selectedOptions[key] === undefined || selectedOptions[key] === '') return null;
    }
    for (var i = 0; i < blockData.variants.length; i++) {
      var v = blockData.variants[i];
      var match = true;
      var v1 = (v.option1 != null ? String(v.option1) : '').trim();
      var v2 = (v.option2 != null ? String(v.option2) : '').trim();
      var v3 = (v.option3 != null ? String(v.option3) : '').trim();
      if (selectedOptions.option1 !== undefined && v1 !== selectedOptions.option1) match = false;
      if (selectedOptions.option2 !== undefined && v2 !== selectedOptions.option2) match = false;
      if (selectedOptions.option3 !== undefined && v3 !== selectedOptions.option3) match = false;
      if (match) return v;
    }
    return null;
  }

  function getSelectedOptions(block) {
    var blockId = block.getAttribute('data-block-id');
    var blockData = variantData[blockId];
    if (!blockData || blockData.hasOnlyDefaultVariant) return {};
    var options = {};
    block.querySelectorAll('.bk-media-bundle__option-select').forEach(function(sel) {
      var val = (sel.value || '').trim();
      if (val === '') return;
      var pos = parseInt(sel.getAttribute('data-option-position'), 10);
      options['option' + pos] = val;
    });
    return options;
  }

  function getVariantForBlock(block) {
    var blockId = block.getAttribute('data-block-id');
    var hiddenInput = block.querySelector('.bk-media-bundle__variant-id');
    if (hiddenInput) {
      var vid = parseInt(hiddenInput.value, 10);
      var blockData = variantData[blockId];
      if (blockData) {
        for (var i = 0; i < blockData.variants.length; i++) {
          if (blockData.variants[i].id === vid) return blockData.variants[i];
        }
      }
      return null;
    }
    return findVariant(blockId, getSelectedOptions(block));
  }

  function updateVariantImage(block, variant) {
    var imageWrap = block.querySelector('[data-product-image]');
    if (!imageWrap || !variant || !variant.image) return;
    var img = imageWrap.querySelector('img');
    if (img) {
      img.src = variant.image;
    } else {
      img = document.createElement('img');
      img.src = variant.image;
      img.alt = (block.querySelector('[data-product-title]') || {}).textContent || '';
      img.loading = 'lazy';
      img.className = 'rounded';
      imageWrap.innerHTML = '';
      imageWrap.appendChild(img);
    }
  }

  function allCheckedHaveValidVariant() {
    var blocks = bundle.querySelectorAll('.bk-media-bundle__product');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var cb = block.querySelector('.bk-media-bundle__product-checkbox');
      if (!cb || !cb.checked) continue;
      var variant = getVariantForBlock(block);
      if (!variant || !variant.available) return false;
    }
    return true;
  }

  function hasCheckedProducts() {
    return bundle.querySelectorAll('.bk-media-bundle__product-checkbox:checked').length > 0;
  }

  function collectCartItems() {
    var items = [];
    bundle.querySelectorAll('.bk-media-bundle__product').forEach(function(block) {
      var cb = block.querySelector('.bk-media-bundle__product-checkbox');
      if (!cb || !cb.checked) return;
      var variant = getVariantForBlock(block);
      if (variant && variant.id) items.push({ id: variant.id, quantity: 1 });
    });
    return items;
  }

  function readBundleQtyDiscount(bundleRoot) {
    var pct = parseInt(String(bundleRoot.getAttribute('data-bundle-qty-discount-percent') || '0'), 10);
    var minQty = parseInt(String(bundleRoot.getAttribute('data-bundle-qty-discount-min') || '2'), 10);
    if (isNaN(pct) || pct < 0) pct = 0;
    if (isNaN(minQty) || minQty < 1) minQty = 2;
    return { pct: pct, minQty: minQty };
  }

  function sumPerUnitQtyDiscount(priceList, pct) {
    var total = 0;
    for (var i = 0; i < priceList.length; i++) {
      var p = priceList[i];
      var unitDiscount = Math.floor(p * pct / 100);
      total += p - unitDiscount;
    }
    return total;
  }

  function updateSubtotal() {
    var lines = [];
    bundle.querySelectorAll('.bk-media-bundle__product').forEach(function(block) {
      var cb = block.querySelector('.bk-media-bundle__product-checkbox');
      if (!cb || !cb.checked) return;
      var variant = getVariantForBlock(block);
      if (variant) lines.push({ price: variant.price, compareAt: variant.compareAtPrice || 0 });
    });

    var totalPrice = 0;
    var totalCompare = 0;
    var priceRow = [];
    for (var j = 0; j < lines.length; j++) {
      totalPrice += lines[j].price;
      priceRow.push(lines[j].price);
      totalCompare += (lines[j].compareAt > 0 ? lines[j].compareAt : lines[j].price);
    }

    var cfg = readBundleQtyDiscount(bundle);
    var qtyTierActive = cfg.pct > 0 && lines.length >= cfg.minQty;
    var discountedSum = qtyTierActive ? sumPerUnitQtyDiscount(priceRow, cfg.pct) : totalPrice;

    var priceEl = bundle.querySelector('[data-bundle-price]');
    var compareEl = bundle.querySelector('[data-compare-price]');
    var badgeEl = bundle.querySelector('[data-discount-badge]');

    function fmtMoney(cents) {
      return (window.Shopify && window.Shopify.formatMoney) ? window.Shopify.formatMoney(cents) : (cents / 100).toFixed(2) + ' €';
    }

    if (priceEl) priceEl.textContent = fmtMoney(discountedSum);

    if (compareEl) {
      var showStrike = false;
      var strikeAmt = 0;
      if (qtyTierActive && discountedSum < totalPrice) {
        showStrike = true;
        strikeAmt = totalPrice;
      } else if (!qtyTierActive && totalCompare > totalPrice && totalCompare > 0) {
        showStrike = true;
        strikeAmt = totalCompare;
      }
      compareEl.style.display = showStrike && strikeAmt > 0 ? '' : 'none';
      if (showStrike && strikeAmt > 0) compareEl.textContent = fmtMoney(strikeAmt);
    }

    if (badgeEl) {
      if (qtyTierActive && discountedSum < totalPrice) {
        badgeEl.textContent = '-' + cfg.pct + '%';
        badgeEl.style.display = '';
      } else if (!qtyTierActive && totalCompare > totalPrice && totalCompare > 0) {
        badgeEl.textContent = '-' + Math.round((1 - totalPrice / totalCompare) * 100) + '%';
        badgeEl.style.display = '';
      } else {
        badgeEl.style.display = 'none';
      }
    }
  }

  function updateButtonState() {
    var btn = bundle.querySelector('[data-bundle-add]');
    if (!btn) return;
    var disabledEl = btn.querySelector('[data-button-text-disabled]');
    var enabledEl = btn.querySelector('[data-button-text-enabled]');
    if (!hasCheckedProducts()) {
      btn.disabled = true;
      if (disabledEl) disabledEl.classList.remove('hidden');
      if (enabledEl) enabledEl.classList.add('hidden');
      return;
    }
    var canAdd = allCheckedHaveValidVariant();
    btn.disabled = !canAdd;
    if (canAdd) {
      if (disabledEl) disabledEl.classList.add('hidden');
      if (enabledEl) enabledEl.classList.remove('hidden');
    } else {
      if (disabledEl) disabledEl.classList.remove('hidden');
      if (enabledEl) enabledEl.classList.add('hidden');
    }
  }

  function onSelectionChange() {
    updateSubtotal();
    updateButtonState();
  }

  bundle.querySelectorAll('.bk-media-bundle__option-select').forEach(function(sel) {
    sel.addEventListener('change', function() {
      var block = sel.closest('.bk-media-bundle__product');
      if (block) updateVariantImage(block, getVariantForBlock(block));
      onSelectionChange();
    });
  });

  bundle.querySelectorAll('.bk-media-bundle__product-checkbox').forEach(function(cb) {
    cb.addEventListener('change', onSelectionChange);
  });

  bundle.querySelectorAll('.bk-media-bundle__product').forEach(function(block) {
    updateVariantImage(block, getVariantForBlock(block));
  });

  bundle.querySelectorAll('.bk-media-bundle__option-select').forEach(function(sel) {
    var opts = sel.querySelectorAll('option');
    if (opts.length === 2 && opts[0].value === '' && opts[1].value !== '') {
      sel.value = opts[1].value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  onSelectionChange();

  var btn = bundle.querySelector('[data-bundle-add]');
  if (btn) {
    btn.addEventListener('click', function() {
      var items = collectCartItems();
      if (items.length === 0) return;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      var cartDrawer = document.querySelector('cart-drawer');
      var sectionIdCart = cartDrawer ? (cartDrawer.getAttribute('data-section-id') || 'cart-drawer') : 'cart-drawer';
      var sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
      if (sectionsToBundle.indexOf(sectionIdCart) === -1) sectionsToBundle.push(sectionIdCart);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sectionsToBundle.join(',') })
      })
      .then(function(res) { return res.json(); })
      .then(function(responseJson) {
        if (responseJson.status && responseJson.status === 422) throw new Error(responseJson.description || 'Failed to add items');
        if (!responseJson.id && !responseJson.items) throw new Error(responseJson.description || 'Failed to add items');
        return fetch(root + 'cart.js').then(function(r) { return r.json(); }).then(function(cartContent) {
          cartContent.sections = Object.assign(cartContent.sections || {}, responseJson.sections || {});
          if (!responseJson.sections || !responseJson.sections[sectionIdCart]) {
            return fetch(root + 'cart?section_id=' + sectionIdCart).then(function(r) { return r.text(); }).then(function(html) {
              var div = document.createElement('div');
              div.innerHTML = html;
              var newDrawer = div.querySelector('#cart-drawer');
              if (newDrawer) {
                if (!responseJson.sections) responseJson.sections = {};
                responseJson.sections[sectionIdCart] = newDrawer.outerHTML;
              }
              cartContent.sections = Object.assign(cartContent.sections || {}, responseJson.sections || {});
              return cartContent;
            });
          }
          return cartContent;
        }).then(function(cartContent) {
          var form = document.querySelector('form[is="product-form"]') || document.createElement('form');
          if (!form.parentNode) document.body.appendChild(form);
          var addedItems = responseJson.items || [responseJson];
          form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: addedItems, cart: cartContent } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
          if (form.parentNode && form.parentNode === document.body) form.parentNode.removeChild(form);
        });
      })
      .catch(function(err) {
        console.error('Bundle add to cart error:', err);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .finally(function() {
        btn.removeAttribute('aria-busy');
        updateButtonState();
      });
    });
  }
}

window.initBundleBlock = initBundleBlock;

function initTimerBlock(timerElement) {
  var daysEl = timerElement.querySelector('.bk-media-timer-block__timer-days');
  var hoursEl = timerElement.querySelector('.bk-media-timer-block__timer-hours');
  var minutesEl = timerElement.querySelector('.bk-media-timer-block__timer-minutes');
  var secondsEl = timerElement.querySelector('.bk-media-timer-block__timer-seconds');
  var timerBlock = timerElement.closest('.bk-media-timer-block');
  var progressBarFill = timerBlock ? timerBlock.querySelector('.bk-media-timer-block__progress-bar-fill') : null;

  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
    console.warn('Timer block elements not found', timerElement);
    return;
  }

  var metaobjectDate = (timerElement.getAttribute('data-metaobject-date') || '').trim();
  var metaobjectStartDate = (timerElement.getAttribute('data-metaobject-start-date') || '').trim();

  var endTime;

  function parseDateToTimestamp(dateString) {
    if (!dateString) return null;
    var trimmed = dateString.trim();
    if (!trimmed) return null;

    var numeric = parseInt(trimmed, 10);
    if (!isNaN(numeric) && numeric > 0) {
      return numeric < 10000000000 ? numeric * 1000 : numeric;
    }

    var parsed = new Date(trimmed);
    if (!isNaN(parsed.getTime())) return parsed.getTime();

    return null;
  }

  if (metaobjectDate) {
    endTime = parseDateToTimestamp(metaobjectDate);
    if (endTime == null) {
      console.warn('Failed to parse metaobject date:', metaobjectDate);
      return;
    }
  } else {
    return;
  }

  function updateTimer() {
    var now = Date.now();
    var remaining = Math.max(0, Math.floor((endTime - now) / 1000));

    var days = Math.floor(remaining / 86400);
    remaining = remaining % 86400;
    var hours = Math.floor(remaining / 3600);
    remaining = remaining % 3600;
    var mins = Math.floor(remaining / 60);
    var secs = remaining % 60;

    daysEl.textContent = days;
    hoursEl.textContent = hours;
    minutesEl.textContent = mins;
    secondsEl.textContent = secs;

    if (progressBarFill) {
      if (metaobjectStartDate) {
        var parsedStartDate = parseDateToTimestamp(metaobjectStartDate);
        if (parsedStartDate !== null && endTime) {
          var calculatedStartTime = parsedStartDate;
          var totalDurationSeconds = Math.floor((endTime - parsedStartDate) / 1000);

          if (totalDurationSeconds > 0) {
            var elapsedSeconds = Math.max(0, Math.floor((now - calculatedStartTime) / 1000));
            var remainingSeconds = Math.max(0, totalDurationSeconds - elapsedSeconds);
            var progress = 0;

            if (elapsedSeconds <= totalDurationSeconds) {
              progress = (remainingSeconds / totalDurationSeconds) * 100;
            } else {
              progress = 0;
            }

            progressBarFill.style.width = Math.min(100, Math.max(0, progress)) + '%';
          }
        }
      }
    }
  }

  updateTimer();
  var interval = setInterval(updateTimer, 1000);

  timerElement.dataset.intervalId = String(interval);
}

function initTimerBlocks() {
  document.querySelectorAll('.bk-media-timer-block__timer').forEach(function(timer) {
    var existingIntervalId = timer.dataset.intervalId;
    if (existingIntervalId) {
      clearInterval(parseInt(existingIntervalId, 10));
      delete timer.dataset.intervalId;
    }

    timer.dataset.initialized = 'true';
    try {
      initTimerBlock(timer);
    } catch (error) {
      console.error('Error initializing timer block:', error, timer);
      timer.dataset.initialized = 'false';
    }
  });
}

function initTimerCopyButtons() {
  document.querySelectorAll('.bk-media-timer-block__code-badge').forEach(function(button) {
    if (button.dataset.copyInitialized) return;
    button.dataset.copyInitialized = 'true';

    button.addEventListener('click', function() {
      var code = this.dataset.code;
      if (!code) return;

      var textEl = this.querySelector('.bk-media-timer-block__code-text');
      var originalText = textEl ? textEl.textContent : '';
      var originalBadgeText = this.textContent;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function() {
          if (textEl) {
            textEl.textContent = 'Kopiert!';
          } else {
            this.textContent = 'CODE: Kopiert!';
          }

          var self = this;
          setTimeout(function() {
            if (textEl) {
              textEl.textContent = originalText;
            } else {
              self.textContent = originalBadgeText;
            }
          }, 2000);
        }.bind(this)).catch(function(err) {
          console.error('Failed to copy code:', err);
        });
      } else {
        var textArea = document.createElement('textarea');
        textArea.value = code;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();

        try {
          document.execCommand('copy');
          if (textEl) {
            textEl.textContent = 'Kopiert!';
          } else {
            this.textContent = 'CODE: Kopiert!';
          }

          var self = this;
          setTimeout(function() {
            if (textEl) {
              textEl.textContent = originalText;
            } else {
              self.textContent = originalBadgeText;
            }
          }, 2000);
        } catch (err) {
          console.error('Failed to copy code:', err);
        } finally {
          document.body.removeChild(textArea);
        }
      }
    });
  });
}

function initializeTimerBlocks() {
  initTimerBlocks();
  initTimerCopyButtons();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initializeTimerBlocks();
  });
} else {
  setTimeout(initializeTimerBlocks, 100);
}

document.addEventListener('shopify:section:load', function() {
  setTimeout(initializeTimerBlocks, 100);
});

document.addEventListener('product:rerender', function() {
  setTimeout(initializeTimerBlocks, 100);
});

document.addEventListener('variant:add', (event) => {
  const quickBuyDrawer = event.target.closest('quick-buy-drawer');
  if (!quickBuyDrawer) return;

  event.stopImmediatePropagation();

  quickBuyDrawer.hide();

  const detail = { ...event.detail, blockCartDrawerOpening: false };
  document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
    bubbles: true,
    detail: { baseEvent: 'variant:add', cart: detail.cart }
  }));
  document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
    bubbles: true,
    detail
  }));
}, true);
